import CssBaseline from "@mui/material/CssBaseline/CssBaseline";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import createTheme from "@mui/material/styles/createTheme";
import { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import packageJson from "../package.json";
import "./App.css";
import { CheckForError } from "./components/CheckForError";
import MaintenancePage from "./components/MaintenancePage";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { getConfig } from "./config";
import {
  CircylCrmContextConfig,
  CircylCrmContextProvider,
} from "./hooks/useApi";
import Layout from "./layout/Layout";
import Contacts from "./pages/Contacts";
import Error from "./pages/Error";
import FAQPage from "./pages/FAQ";
import History from "./pages/History";
import Home from "./pages/Home";
import Login from "./pages/Login";
import NotFoundPage from "./pages/NotFoundPage";
import RecentlyApproved from "./pages/RecentlyApproved";
import Register from "./pages/Register";
import Settings from "./pages/Settings";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#005292",
    },
    secondary: {
      main: "#F57D00",
    },
    text: {
      primary: "#000000",
    },
    background: {
      default: "#005292",
      paper: "#ffffff",
    },
    // hoverOverColor: "#B0CD5920", //"#fff200a1",
    // hoverBorderHighlightColor: "#B0CD59",
  },

  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "white",
          color: "black",
        },
        root: {
          fontFamily: "'Roboto', sans-serif",
        },
      },
    },
    // MuiIcon: {
    //   styleOverrides: {
    //     root: {
    //       color: "red",
    //     },
    //   },
    // },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: "rgba(0, 0, 0, 0.5)",
          "&.Mui-disabled": {
            color: "rgba(0, 0, 0, 0.2)",
          },
        },
      },
    },
    // MuiSvgIcon: {
    //   styleOverrides: {
    //     root: {
    //       color: "rgba(0, 0, 0, 0.5)",
    //       // color: "red",
    //     },
    //   },
    // },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: "20px",
          paddingRight: "10px",
          color: "rgba(0, 0, 0, 0.5)",
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        secondary: {
          color: "black",
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "rgb(0,82,146,0.1)",
          },
        },
      },
    },
  },

  typography: {
    fontFamily: ["Roboto", "sans-serif"].join(","),
  },

  breakpoints: {
    values: {
      xs: 0,
      sm: 900,
      // sm: 600,
      md: 1200,
      // md: 900,
      lg: 1500,
      // lg: 1200,
      xl: 1536,
    },
  },
});

console.log("version", packageJson.version);

function App() {
  const [buttonsLocked, setButtonsLocked] = useState<boolean>(false);
  const [isApiError, setIsApiError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();

  const config = getConfig();

  const circylCrmConfig: CircylCrmContextConfig = {
    isApiError,
    setIsApiError,
    errorMessage,
    setErrorMessage,
    buttonsLocked,
    setButtonsLocked,
  };

  // Check for maintenance mode
  if (config.maintenanceMode) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <MaintenancePage
          message={config.maintenanceMessage}
          estimatedEnd={config.maintenanceEstimatedEnd || undefined}
        />
      </ThemeProvider>
    );
  }

  return (
    <CircylCrmContextProvider value={circylCrmConfig}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <CheckForError />
          <Routes>
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Home />} />
              <Route path="history" element={<History />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="settings" element={<Settings />} />
              <Route path="faq" element={<FAQPage />} />
              <Route path="recentlyapproved" element={<RecentlyApproved />} />
            </Route>
            <Route path="login" element={<Login />} />
            <Route path="register" element={<Register />} />
            <Route path="error" element={<Error />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </CircylCrmContextProvider>
  );
}

export default App;
